import { deepMerge } from 'js/utils/Utils'
import { gsap } from 'gsap'
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'BaseSlideshow',
  $name: {
    wrapper: '[data-slideshow-wrap]',
    list: '[data-slideshow-list]',
    item: '[data-slideshow-item]',
  },
  timerInfo: {
    duration: 2.5,
  },
  isAutoPlay: true,
  minNumber: 0,
  useIom: true,
}

export default class BaseSlideshow {
  constructor(options = {}) {
    this.callback = {
      next: async () => {
        await new Promise((resolve) => resolve())
      },
      prev: async () => {
        await new Promise((resolve) => resolve())
      },
      updateIndicator: async () => {
        await new Promise((resolve) => resolve())
      },
    }

    this.$contentRoot = document
    this.$wrapper = null
    this.$list = null
    this.$items = null

    this.isAnimating = false
    this.enableTimer = false

    this.timer = {
      tween: null,
      value: 0,
    }

    this.itemLength = 0
    this.numberState = {
      prev: 0,
      current: 0,
      next: 0,
    }

    this.maxNumber = 0
    this.minNumber = 0

    this.isInVIew = false
    this.enableAutoPlay = true

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()

    if (!this.$wrapper || !this.$list || !this.$items) return

    this._setInfo()
    // this._addEventList()
  }

  run() {
    if (this.useIom) {
      this.addIom()
    } else {
      this.isInVIew = true
      if (this.isAutoPlay) {
        this.start()
      }
    }
  }

  destroy() {
    // this._removeEventList()
    this.stop()
    this.removeIom()
  }

  _set$() {
    this.$wrapper = this.$wrapper || this.$contentRoot.querySelector(this.$name.wrapper)
    if (this.$wrapper) {
      this.$list = this.$wrapper.querySelector(this.$name.list)
      if (this.$list) {
        this.$items = this.$list.querySelectorAll(this.$name.item)
      }
    }
  }

  _setInfo() {
    this.itemLength = this.$items.length
    this.maxNumber = this.itemLength - 1
    // this.minNumber = 0

    this.setNumberState(0)
  }

  async setNumberState(currentNumber = 0) {
    await new Promise((resolve) => {
      if (currentNumber === this.minNumber) {
        this.numberState.prev = this.maxNumber
      } else {
        this.numberState.prev = currentNumber - 1
      }

      this.numberState.current = currentNumber
      this.numberState.next = (currentNumber + 1) % this.itemLength

      resolve()
    })
  }

  // _addEventList() {
  // }

  // _removeEventList() {
  // }

  addIom() {
    if (this.useIom) {
      if (Common.iom) {
        Common.iom.add(
          this.$wrapper,
          () => {
            if (!this.isInVIew) {
              this.isInVIew = true
              this.start()
            }
          },
          () => {
            if (this.isInVIew) {
              this.isInVIew = false
              this.stop()
            }
          }
        )
      }
    }
  }

  removeIom() {
    if (this.useIom) {
      if (Common.iom) {
        Common.iom.remove(this.$wrapper)
      }
    }
  }

  start() {
    if (this.isAutoPlay && this.enableAutoPlay) {
      this.runAutoTimer()
    }
  }

  stop() {
    if (this.timer && this.timer.tween) {
      this.timer.tween.pause()
    }
  }

  runAutoTimer() {
    if (this.timer && this.timer.tween) {
      this.timer.tween.pause()
    }

    this.timer.tween = gsap.to(this.timer, {
      value: 1,
      duration: this.timerInfo.duration,
      onUpdate: () => {
        this.callback.updateIndicator()
      },
      onComplete: () => {
        this.next().then(() => {
          if (this.timer && this.timer.tween) {
            this.timer.tween.pause()
            this.timer.tween.kill()
            this.timer.value = 0
          }

          if (this.isAutoPlay && this.enableAutoPlay) {
            this.runAutoTimer()
          }
        })
      },
    })
  }

  async next() {
    await this.callback.next()
    await this.setNumberState(this.numberState.next)
  }

  async prev() {
    await this.callback.prev()
    await this.setNumberState(this.numberState.prev)
  }

  // onResize() {}
}